import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
    Survey,
    SurveyQuestion,
    SurveyQuestionType
} from '@lsq-frontend/remote-services/enterprise/common';
import { ModalService } from '../../../services/modal/modal.service';

@Component({
    selector: 'lsq-question-modal',
    template: `
        <div [formGroup]="formGroup" class="lsq-question-modal">
            <div
                class="question-wrapper"
                *ngIf="question.surveyQuestionType === questionTypes.Radio"
            >
                <label class="question-text">{{ question.question }} </label>
                <lsq-radio-list
                    [vertical]="true"
                    label="Option List"
                    [options]="question.options"
                    [group]="formGroup"
                    [formControlName]="questionControlName"
                    [name]="questionControlName"
                >
                </lsq-radio-list>
            </div>

            <div
                class="question-wrapper"
                *ngIf="question.surveyQuestionType === questionTypes.Checkbox"
            >
                <label class="question-text">{{ question.question }} (Select all that apply)</label>
                <lsq-checklist
                    [items]="question.options"
                    [group]="formGroup"
                    [formControlName]="questionControlName"
                >
                </lsq-checklist>
            </div>

            <div
                class="question-wrapper"
                *ngIf="question.surveyQuestionType === questionTypes.TextArea"
            >
                <label class="question-text">{{ question.question }} </label>
                <lsq-textarea
                    [basicLabel]="true"
                    [group]="formGroup"
                    [formControlName]="questionControlName"
                    rows="4"
                >
                </lsq-textarea>
            </div>

            <div *ngIf="totalQuestionCount > 1" class="question-progress">
                <div
                    *ngFor="let i of counterArray()"
                    class="question-progress-dash"
                    [ngClass]="{ active: i <= this.question.order }"
                ></div>
            </div>
            <div *ngIf="totalQuestionCount > 1" class="question-count">
                <span> Question {{ question.order }} of {{ totalQuestionCount }} </span>
            </div>
        </div>
    `,
    styleUrls: ['./lsq-question-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class LsqQuestionModalComponent implements OnInit {
    public isPreview = false;
    public formGroup: FormGroup;
    public survey: Survey;
    public question: SurveyQuestion;
    public questionControlName: string;
    public questionTypes = SurveyQuestionType;
    public totalQuestionCount: number;

    constructor(public modalService: ModalService) {}

    public ngOnInit(): void {
        const modalData = this.modalService.modal.data;
        if (modalData) {
            this.isPreview = modalData.isPreview;
            this.formGroup = modalData.formGroup;
            this.survey = modalData.survey;
            this.question = modalData.question;
            this.questionControlName = modalData.questionControl;
            this.totalQuestionCount = modalData.totalQuestionCount;
        }
    }

    public counterArray(): number[] {
        return Array.from({ length: this.totalQuestionCount }, (x, i) => i + 1);
    }
}
